/**
 * @file
 * Device switcher script.
 */

(function deviceSwitcherScript($, Drupal) {
  'use strict';

  function getMobileOperatingSystem() {
    var userAgent = navigator.userAgent || navigator.vendor || window.opera;

    if (/android/i.test(userAgent)) {
      return 'android';
    }
    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
      return 'apple';
    }
    return 'web';
  }

  Drupal.behaviors.deviceSwitcher = {
    attach: function deviceSwitcherAttach(context) {
      var deviceType = getMobileOperatingSystem();

      $('[data-device="' + deviceType + '"]', context).addClass('device-switcher__toggle--active').attr('aria-selected', 'true');
      $('.device-filter__content', context).hide();
      $('[data-content="' + deviceType + '"]', context).fadeIn().attr('aria-hidden', 'false');

      $('.device-switcher__toggle', context)
        .hammer()
        .on('tap press click', function (e) {
          e.preventDefault();
          var $this = $(this);

          if (!$this.hasClass('device-switcher__toggle--active')) {
            var thisDevice = $this.data('device');
            // Update active toggle.
            $('.device-switcher', context).find('.device-switcher__toggle')
              .removeClass('device-switcher__toggle--active').attr('aria-selected', 'false');
            $this.addClass('device-switcher__toggle--active').attr('aria-selected', 'true');
            // Show the related content.
            $('.device-filter', context).find('.device-filter__content')
              .hide().attr('aria-hidden', 'true');
            $('.device-filter', context).find('[data-content="' + thisDevice + '"]')
              .fadeIn().attr('aria-hidden', 'false');
          }
        });
    }
  };
}(jQuery, Drupal));
